import{j as o,k as r}from"./chunk-SGUETU3K.mjs";var m=new o({locale:r});export{m as a};
